import {RaEvent, RaEventType} from "../event/RaEvent";

export class QuestionReportEvent extends RaEvent {

    static TYPE:RaEventType = "question_report_event";

    constructor() {
        super(QuestionReportEvent.TYPE);
    }

}
